// checkbox logic
$('.update-ep-checkbox').on('click', function (event) {
    let checkbox = $(event.target);
    let input = checkbox.parent().prev().find('.update_quantity');
    epAlert(checkbox, input, event.target);
});

$('.form-ep-update').on('click', function (event) {
    let checkbox = $(event.target);
    let input = $('.form-quantity');
    epAlert(checkbox, input, event.target);
});

//able enter to save the Article Quantity and Price in the Offer Positions
$('.update_quantity, .update_price').keyup(function (event) {
    if (event.keyCode === 13) {
        updateArticle(event.target.form);
    }
});

//fire alert if quantity is <> 1
function epAlert(checkbox, input, target) {
    const quantity = parseFloat(input.val().replace(',', '.'));

    if (checkbox.prop('checked') && quantity !== 1.) {
        Swal.fire({
            title: 'Warnung',
            icon: 'warning',
            text: 'Menge ist nicht 1, trotzdem fortfahren?',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'Nein',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            confirmButtonColor: '#3085d6',
        }).then((result) => {
            if (result.isConfirmed && checkbox.hasClass('update-ep-checkbox')) {
                checkbox.prop('checked', true);
                updateArticle(target.form);
            } else if (result.isConfirmed && checkbox.hasClass('form-ep-update')) {
                checkbox.prop('checked', true);
            } else {
                checkbox.prop('checked', false);
            }
        });
    } else {
        updateArticle(event.target.form);
    }
}

function updateArticle(form) {
    let data = $(form).serialize();
    $.ajax({
        type: "POST",
        url: form.action,
        data: data,
        success: function () {
            Livewire.dispatch('articleUpdated')
            Swal.fire({
                text: "Artikel wurde erfolgreich bearbeitet.",
                icon: "success",
                showConfirmButton: false,
                toast: true,
                position: 'top-end',
                timer: 2000
            });
        }
    });
}
